const labelList = {
    path: 'labelList',
    component: resolve => require(['@/pages/admin/message/labelList.vue'], resolve)
}

export default labelList